import React from "react";
import classNames from "classnames";
import { uniqueId } from "lodash";

export type SliderProps = React.InputHTMLAttributes<HTMLInputElement> & {
    className?: string;
    sliderClassName?: string;
    label?: string;
    description?: string;
    id?: string;
    min?: number;
    max?: number;
    showRange?: boolean;
    rangePosition?: "horizontal" | "vertical";
    customLeftLabel?: string;
    customRightLabel?: string;
    step?: number;
    value?: number;
    defaultValue?: number;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    disabled?: boolean;
};

export default function Slider({
    className,
    sliderClassName,
    label,
    description,
    id,
    min,
    max,
    showRange,
    rangePosition = "horizontal",
    customLeftLabel,
    customRightLabel,
    step,
    defaultValue,
    value,
    onChange,
    disabled,
    ...props
}: SliderProps) {
    const inputId = id ? id : uniqueId();

    return (
        <div className={classNames("sliderWithLabel text-sm", className)}>
            {label && (
                <label htmlFor={inputId} className="sliderLabel">
                    <span>{label}</span>
                    {description && <span className="description">{description}</span>}
                </label>
            )}
            {rangePosition === "vertical" ? (
                <div className={classNames("sliderContainer vertical", sliderClassName)}>
                    <input
                        type="range"
                        className="roboslider"
                        id={inputId}
                        min={min}
                        max={max}
                        step={step}
                        defaultValue={defaultValue}
                        value={value}
                        onChange={onChange}
                        disabled={disabled}
                        {...props}
                    />
                    {showRange && (
                        <div className="sliderRange">
                            <span>{customLeftLabel ? customLeftLabel : min}</span>
                            <span>{customRightLabel ? customRightLabel : max}</span>
                        </div>
                    )}
                </div>
            ) : (
                <div className={classNames("sliderContainer", sliderClassName)}>
                    {showRange && <span>{customLeftLabel ? customLeftLabel : min}</span>}
                    <input
                        type="range"
                        className="roboslider"
                        id={inputId}
                        min={min}
                        max={max}
                        step={step}
                        defaultValue={defaultValue}
                        value={value}
                        onChange={onChange}
                        disabled={disabled}
                        {...props}
                    />
                    {showRange && <span>{customRightLabel ? customRightLabel : max}</span>}
                </div>
            )}
        </div>
    );
}
